import { createContext, useContext } from "react";

export const ViewsContext = createContext();

// Custom hook to use ViewsContext
export const useBoardViews = () => {
  const context = useContext(ViewsContext);
  if (!context) {
    throw new Error("useBoardViews must be used within a ViewsProvider");
  }
  return context;
};
